"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SVG = _interopRequireDefault(require("./SVG"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronLeftIcon = function ChevronLeftIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      style = _ref.style,
      viewBox = _ref.viewBox,
      fill = _ref.fill,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_SVG.default, {
    style: style,
    width: width || '32',
    height: height || '32',
    viewBox: viewBox || '0 0 32 32',
    fill: fill,
    className: className,
    path: "M11.3107 16L18.2803 9.24153C18.5732 8.95751 18.5732 8.49703 18.2803 8.21301C17.9874 7.929 17.5126 7.929 17.2197 8.21301L9.71967 15.4857C9.42678 15.7698 9.42678 16.2302 9.71967 16.5143L17.2197 23.787C17.5126 24.071 17.9874 24.071 18.2803 23.787C18.5732 23.503 18.5732 23.0425 18.2803 22.7585L11.3107 16Z"
  });
};

var _default = ChevronLeftIcon;
exports.default = _default;